/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tools/view.blocks to change it.
import AttachmentAction from './AttachmentAction/index'
import React from 'react'
import Secure from './Secure/index'
import SendAction from './SendAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tools({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Tools.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AttachmentAction
  viewPath={`${viewPath}/AttachmentAction`}
/>
<Secure
  viewPath={`${viewPath}/Secure`}
/>
<SendAction
  viewPath={`${viewPath}/SendAction`}
/>
</div>
{children}
</React.Fragment>)
}